const office = {
  editor: {
    noFileId: 'No se proporcionó ID de archivo',
    failedToStartSession: 'Error al iniciar la sesión de edición',
    errorLoadingDocument: 'Error al cargar el documento',
  },
};

export const es = {
  office,
};
